import React from 'react'
import { gql, useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import DeleteOutlineOutlined from 'components/material-symbol/icons/DeleteOutline'
import Dialog from 'components/dialog'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'
import { useAuth } from 'lib/auth'

const DELETE_FACILITY = gql`
  mutation RemoveCoachFacility($coachId: ID!, $facilityId: ID!) {
    removeCoachFacility(coachId: $coachId, facilityId: $facilityId) {
      success
      message
    }
  }
`

const DeleteFacilityDialog = ({ trigger, facilityId, onSuccess }) => {
  const classes = useDialogTitleStyles()
  const { user } = useAuth()
  const [deleteFacility, { loading }] = useMutation(DELETE_FACILITY)
  const { enqueueSnackbar } = useSnackbar()

  return (
    <Dialog
      trigger={trigger}
      maxWidth="xs"
      fullWidth
      showCloseButton
      disableClose={loading}
      classes={{ paper: classes.dialogPaper }}
    >
      {({ closeDialog }) => {
        const onDeleteFacilityConfirm = () => {
          deleteFacility({ variables: { coachId: user.id, facilityId } }).then(
            ({ data }) => {
              if (data.removeCoachFacility.success) {
                enqueueSnackbar('Successfully deleted facility', {
                  variant: 'success',
                })
                closeDialog()
                onSuccess && onSuccess()
              } else {
                enqueueSnackbar('Unable to delete facility', {
                  variant: 'error',
                })
              }
            },
          )
        }

        return (
          <>
            <DialogTitle
              disableTypography
              classes={{ root: classes.titleRoot }}
            >
              <Typography component="h2" className={classes.title}>
                Delete Facility
              </Typography>
              <Typography className={classes.bodyText}>
                This facility will be removed from your coach profile.
              </Typography>
            </DialogTitle>
            <DialogContent classes={{ root: classes.content }}>
              <Typography className={classes.bodyText}>
                Are you sure you want to delete this facility? All booking types
                associated to this facility will be deleted.
              </Typography>
            </DialogContent>
            <DialogActions className={classes.actions}>
              <Button
                color="primary"
                size="large"
                onClick={closeDialog}
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                variant="contained"
                size="large"
                disableElevation
                startIcon={<DeleteOutlineOutlined fontSize="small" />}
                onClick={onDeleteFacilityConfirm}
                disabled={loading}
              >
                Delete Facility
              </Button>
            </DialogActions>
          </>
        )
      }}
    </Dialog>
  )
}

export default DeleteFacilityDialog
